<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<ng-container *ngIf="this.authService.isAuthenticated()">
	<app-main-page *ngIf="this.authService.isVerified()"></app-main-page>
	<app-user-set-password *ngIf="!this.authService.isVerified()"></app-user-set-password>
</ng-container>

<app-sign-in *ngIf="!this.authService.isAuthenticated()"></app-sign-in>

<app-session-timeout-notification></app-session-timeout-notification>
